import { useState } from 'react';
import {Col, Container, Row} from "react-bootstrap";
import { FaServicestack } from "react-icons/fa";
import {IoIosArrowDown} from "react-icons/io";

function Services({ services }) {
    const [visibleCount, setVisibleCount] = useState(6);
  
    const showMore = () => {
      setVisibleCount(services.length);
    };
  
    return (
      <Container className="my-lg-4">
        <h2 className="my-3 fw-semibold text-center text-warning">Our Services</h2>
        <Row>
          {services.data.slice(0, visibleCount).map(service => (
            <Col lg={4} key={service.id} className="mb-3">
              <div className="card rounded-4 h-100">
                <div className="card-body">
                  <div className="service">
                    <h4 className="my-0 text-success fw-semibold mb-3 fs-6">
                      {service.name}
                    </h4>
                    <p className="small text-black mb-0">{service.description}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
  
        <div className="text-center">
          {visibleCount < services.length && (
            <button
              className="btn fw-semibold tw-text-primary rounded-pill"
              onClick={showMore}
            >
              Show More <IoIosArrowDown />
            </button>
          )}
        </div>
      </Container>
    );
  }
  



export default Services;
